import { createContext, PropsWithChildren, useContext, useState } from 'react'
import { SelectedImage } from 'types'

type AddMoreImagesContextValue = {
  selectedImages: SelectedImage[]
  setSelectedImages: React.Dispatch<React.SetStateAction<SelectedImage[]>>
  availableImages: (SelectedImage | string)[]
  setAvailableImages: React.Dispatch<React.SetStateAction<(string | SelectedImage)[]>>
  toggleSelectedImage: (image: SelectedImage) => void
}

export const AddMoreImagesContext = createContext<AddMoreImagesContextValue>({
  selectedImages: [],
  availableImages: [],
  setSelectedImages: () => {},
  setAvailableImages: () => {},
  toggleSelectedImage: () => {},
})

const AddMoreImagesContextProvider = AddMoreImagesContext.Provider

export const AddMoreImagesProvider = ({ ...props }: PropsWithChildren) => {
  const [selectedImages, setSelectedImages] = useState<SelectedImage[]>([])
  const [availableImages, setAvailableImages] = useState<(SelectedImage | string)[]>([])

  const toggleSelectedImage = (image: SelectedImage) => {
    setSelectedImages((images: SelectedImage[]) => {
      if (images.some(({ url }) => url === image.url)) {
        return images.filter(({ url }) => url !== image.url)
      }

      return [...images, image]
    })
  }

  return (
    <AddMoreImagesContextProvider
      value={{
        selectedImages,
        setSelectedImages,
        availableImages,
        setAvailableImages,
        toggleSelectedImage,
      }}
    >
      {props.children}
    </AddMoreImagesContextProvider>
  )
}

export const useAddMoreImagesContext = () => {
  return useContext(AddMoreImagesContext)
}
